export default {
    encoding: [
        {
            name: 'value',
            type: 'number',
            desc: 'Specify the dataSource applied to the value of marker gauge.',
            defaultValue: 'primary[0][-1]',
            isRequired: 'true',
        },
    ],
    events: [],
};
